export class RegistrationDetail {
    public id?: number;
    public deleted?: boolean;
    public version?: number;
    public price?: number;
    public priceCurrency?: string;
    public registrationId?: number;
    public studentId?: number;
    public mailSent?: boolean;
    public contactId?: number;
    public commercialId?: number;
    public opcaStatus?: string;
    public conventionSent?: boolean;
    public registrationDetailId?: number;

    constructor(
        id?: number,
        deleted?: boolean,
        version?: number,
        price?: number,
        priceCurrency?: string,
        registrationId?: number,
        studentId?: number,
        mailSent?: boolean,
        contactId?: number,
        commercialId?: number,
        opcaStatus?: string,
        conventionSent?: boolean,
        registrationDetailId?: number
    ) {
        this.id = id ? id : null;
        this.deleted = deleted ? deleted : null;
        this.version = version ? version : null;
        this.price = price ? price : null;
        this.priceCurrency = priceCurrency ? priceCurrency : null;
        this.registrationId = registrationId ? registrationId : null;
        this.studentId = studentId ? studentId : null;
        this.mailSent = mailSent ? mailSent : null;
        this.contactId = contactId ? contactId : null;
        this.commercialId = commercialId ? commercialId : null;
        this.opcaStatus = opcaStatus ? opcaStatus : null;
        this.conventionSent = conventionSent ? conventionSent : null;
        this.registrationDetailId = registrationDetailId
            ? registrationDetailId
            : null;
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/registration/registration-detail/registration-detail.model.ts